import React, { Component } from 'react';
import "./App.css";

class ProjectCard extends Component {
    render() {
        return (
            <div style={{"padding":"2rem"}}>
                <figureproject>
                    <h1> {this.props.title} </h1>
                    <p style={{"margin-top": "300px", "color": "grey", "font-family": 'Fuzzy Bubbles', "font-size":"1rem"}}>Launched: {this.props.launch}</p>
                    <figcaption>
                        <h3>Description</h3>
                        <br />
                        <p> {this.props.description} </p>
                        <br />
                        <a className="button" style={{"font-size":"0.8rem"}} href={this.props.link} target="_blank" rel="noopener noreferrer">Visit UI</a>
                    </figcaption>
                </figureproject>
            </div>
        )
    }
};

export { ProjectCard } ;